<template >
  <v-app>
    <!-- Dialog for when account is created -->
    <v-dialog
			v-model="createdDialog"
			width="500px">
      <v-card>
        <v-card-title>

        </v-card-title>
        <v-card-text>
          Congrats on setting up your own My Genetic Trust account. Login to your account to get started with your genetic trust.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="createdDialog = false">
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for creating account -->
    <v-dialog
			v-model="createAccountDialog"
			width="500px">
      <v-card>
        <v-card-title>
          Create Account
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            :v-model="valid && recapRes">
            <v-text-field
              outline
              required
              v-model='setEmail'
              :rules='emailRules'
              @keyup.enter.prevent="createAccount"
              label="Please Enter Your Email Address"></v-text-field>
            <v-text-field
              outline
              required
              :rules='verifyEmailRules'
              @keyup.enter.prevent="createAccount"
              label="Please verify Your Email Address"></v-text-field>
            <v-text-field
              outline
              required
              v-model='setPassword'
              :rules='passwordRules'
              @click:append="show1 = !show1"
              label="Please enter a password."
              :type="show1 ? 'text' : 'password'"
              @keyup.enter.prevent="createAccount"
              :append-icon="show1 ? 'visibility' : 'visibility_off'"></v-text-field>
            <v-text-field
              outline
              required
              :rules='verifyRules'
              :type="show1 ? 'text' : 'password'"
              label="Please verify your password."
              @keyup.enter.prevent="createAccount"></v-text-field>
            <VueRecaptcha :sitekey='recapPubKey' :loadRecaptchaScript="true" @verify="recapValidate"/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            :disabled="!valid"
            @click="createAccount">Send</v-btn>
          <v-btn
            text
            @click="createAccountDialog = false">
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for resetting password -->
    <v-dialog
			v-model="resetPasswordDialog"
			max-width="500px">
      <v-card>
        <v-card-title>
          Reset Password
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid">
            <v-text-field
              v-show='false'></v-text-field>
            <v-text-field
              outline
              required
              :rules='emailRules'
              v-model='resetEmail'
              @keyup.enter.prevent="resetPassword"
              label="Please Enter Your Email Address"></v-text-field>
            <v-btn
              :disabled="!valid"
              color="primary"
              text
              @click="resetPassword">Send</v-btn>
          </v-form>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for payment component -->
    <v-dialog
      v-model='payDialog'
      max-width="500px"
      persistent>
      <Payment
        :modal='payDialog'/>
    </v-dialog>

    <!-- Main page content -->
    <v-content class='bg'>
      <v-container class='fill-height ' fluid>
        <v-row
					align="center"
					justify="center">
          <v-flex
						class='d-flex justify-center align-center'
            md5
						xs12>
            <v-card
							color='#fafafa'
							flat>
							<v-img
								v-if='this.$vuetify.breakpoint.name === "xs" || this.$vuetify.breakpoint.name === "s"'
		            src="../assets/staticAsset/loginheader.png"
		            :width='this.$vuetify.breakpoint.width * 0.85'/>
	            <v-img
								v-else
		            src="../assets/staticAsset/loginheader.png"
		            width='85%'/>
            </v-card>
          </v-flex>
          <v-flex
						v-if='this.$vuetify.breakpoint.name !== "xs"'
						style='height:250px'
						xs1>
						<v-divider style='border-width: thin ' color='white' vertical></v-divider>
					</v-flex>
          <v-flex
            md5>
            <v-card flat color='#fafafa'>
              <v-card-text>
                <v-form
                  ref="Loginform"
                  v-model="Loginvalid">
                  <v-text-field
                    required
                    type="text"
                    name="login"
                    label="Email"
                    v-model='userName'
                    :rules='emailRules'
                    prepend-icon="person"
                    @keyup.enter.prevent="login"></v-text-field>
                  <v-text-field
                    required
                    id="password"
                    name="Password"
                    type="password"
                    label="Password"
                    v-model='password'
                    :rules='fieldRules'
                    prepend-icon="lock"
                    @keyup.enter.prevent="login"></v-text-field>
                  <v-btn
                    block
                    class='mt-5'
                    @click='login'
                    :disabled="!Loginvalid"
                    color="primary">Login</v-btn>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <a @click='resetPasswordDialog = true' class='pr-10'>Forgot Password?</a>
                <v-spacer></v-spacer>
                <a @click='createAccountDialog = true'>Don’t have an account?</a>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import { mapFields } from 'vuex-map-fields';
  import router from '@/router';
  import { createAccount, getUserData } from '../helper/firestore'
  import Payment from '../components/Payment'
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    components: {
      Payment,
      VueRecaptcha
    },
    data() {
      return {
        fieldRules : [
          v => !!v || 'this field is required',
        ],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        passwordRules: [
          v => /[a-z]+/.test(v) || 'One lowercase letter required.',
          v => /[A-Z]+/.test(v) || 'One uppercase letter required.',
          v => /.{8,}/.test(v) || '8 characters minimum.',
          v => /[0-9]+/.test(v) || 'One number required.'
        ],
        verifyRules: [
          v => v === this.setPassword || 'Passwords must match'
        ],
        verifyEmailRules: [
          v => v === this.setEmail || 'Emails must match'
        ],
        valid : true,
        Loginvalid: true,
        resetPasswordDialog : false,
        createAccountDialog : false,
        createdDialog: false,
        payDialog: false,
        show1 : false,
        recapRes : "",
        setEmail : "",
        setPassword: "",
        resetEmail : "",
        userName : "",
        password : "",
        recapPubKey : process.env.VUE_APP_RECAPTCHA_PUBLIC,
      }
    },
    mounted() {
    },
    methods : {
      recapValidate(response) {
        this.recapRes = response
      },
      resetPassword() {
        // Sends password reset email to users email
        const url = 'https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=' + process.env.VUE_APP_ROOT_API_KEY
        const options = {
          "requestType":"PASSWORD_RESET",
          "email":this.resetEmail
        }
        this.$axios
          .post(url, options)
          .then(() => {
            this.snackBarType = "success";
            this.snackBarshow =true;
            this.snackBarmessage = "Password reset email sent, please check your email for resetting instruction.";
            this.resetEmail = "";
            this.resetPasswordDialog = false;
          })
          .catch(() => {
            this.snackBarType = "warning";
            this.snackBarshow =true;
            this.snackBarmessage = "There is no account with this email.";
            this.resetPasswordDialog = false;
          })
      },
      createAccount() {
        var data = {
          email: this.setEmail,
          password: this.setPassword,
          response: this.recapRes
        }
        createAccount(data, (res) => {
          if (res.data.success) {
            this.createAccountDialog = false;
            this.createdDialog = true;
          } else {
            if (res.data.message === 'EMAIL_EXISTS') {
              this.snackBarmessage = "Sorry, this email already exists.";
            } else if (res.data.message === 'RECAPTCHA_ERROR') {
              this.snackBarmessage = "There was a problem with reCaptcha. Please try again.";
            } else {
              this.snackBarmessage = "Error";
            }
            this.createAccountDialog = false;
            this.snackBarType = "warning";
            this.snackBarshow = true;
          }
        })
      },
      login() {
        // logs the user in
        this.$root.$emit('inactive');
        const url = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=' + process.env.VUE_APP_ROOT_API_KEY;
        const options = {
          "email": this.userName,
          "password": this.password,
          "returnSecureToken": true
        }
        this.overlay = true;
        this.$axios
          .post(url, options)
          .then(response => {
            this.user = {
              name : null,
              email : response.data.email,
              uid : response.data.localId,
              idToken : response.data.idToken,
              familyHistory : response.data.qData,
              refreshToken: response.data.refreshToken
            };
            getUserData(response.data.idToken, (result) => {
              this.user = {
                ...this.user,
                ...result.data
              }

              this.user.idToken = response.data.idToken

              if (this.user.familyHistory.length > 0) {
                this.dataModel = this.user.familyHistory;
              } else {
                this.user.familyHistory = this.dataModel;
              }

              // if the user has a valid stripe id they are allowed through
              if (this.user.stripeID) {
                this.isAuthorized = true;
                router.replace('/home');
                this.overlay = false;
              } else {
                this.overlay = false;
                this.payDialog = true;
              }
            })
          })
          .catch(error => {
            this.overlay = false;
            // change snackbar error message based on error code recieved from identity toolkit
            switch (error.response.data.error.message) {
              case 'INVALID_PASSWORD':
                this.snackBarmessage = "Login failed, invalid password."
                break;
              case 'EMAIL_NOT_FOUND':
                this.snackBarmessage = "Login failed, invalid email."
                break;
              case 'TOO_MANY_ATTEMPTS_TRY_LATER : Too many unsuccessful login attempts. Please try again later.':
                this.snackBarmessage = "Login failed, too many unsuccessful attempts."
                break;
              default:
                this.snackBarmessage = "Login failed"
                break;
            }
            this.snackBarType = "warning"
            this.snackBarshow =true
            this.isAuthorized = false
          })
      }
    },
    computed : {
      imageHeight () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'left';
          default : return 'center';
        }
      },
      ...mapFields([
        'isAuthorized',
        'user',
        'overlay',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
      ...mapFields("patientQuestion", [
        "selectedPlan",
        "dataModel",
        "snackbar",
        "errorText",
        "genderList",
        "formID"
      ]),
    },
  }
  </script>
  <style scoped>
  </style>
